import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DataList from "../../components/DataList.jsx";
import ModalContainer from "../../components/ModalContainer.jsx";
import { AllProvincesArray } from "../../utils/convertProvince.js";

const UserAddress = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const findProvinceNameByState = (state) => {
    const province = AllProvincesArray.find((prov) => prov.state === state);
    return province ? province.name : "";
  };

  const addressRows = [
    {
        field: "reciever_name",
        text: "نام گیرنده",
    },
    {
        field: "phone_number",
        text: "شماره تلفن",
    },
    {
        field: "province",
        text: "استان",
    },
    {
        field: "city",
        text: "شهر",
    },
    {
        field: "physical_address",
        text: "آدرس",
    },
    {
        field: "postal_code",
        text: "کد پستی",
    },
  ];

  useEffect(() => {
    if (!location.state) {
      return navigate(-1);
    }
  }, []);

  return (
    <ModalContainer
      alwaysOpen={true}
      fullscreen={false}
      title={`لیست آدرس های کاربر`}
    >
      {location.state?.map((address, index) => (
        <DataList key={index} listData={address} listRowsTitles={addressRows.map(row => {
            if (row.field === "province") {
                return {...row, getValue: () => findProvinceNameByState(address.province)};
            }
            return row;
        })} />
      ))}
    </ModalContainer>
  );
};

export default UserAddress;